<template>
  <div class="Tutorial">
    <Menu />

    <vue-fly-scroll
      v-if="mounted"
      :top="0.1"
      :bottom="0.99"
      :threshold="0"
      :orientation="horizontalScroll ? 'vertical' : 'horizontal'"
      :element="horizontalScroll ? null : $refs.landing"
      @index="index = $event"
      @progress="progress = $event"
      @offset="offset = $event"
    >
      <template v-slot:background>
        <!--btn exit -->
        <div
          v-if="$tvaMq === 'desktop'"
          :class="['go-back', 'button--tertiary', 'step-' + index]"
          @click="goBack()"
        >
          <svgicon
            class="icon-arrow-left"
            icon="icon-arrow-left"
            width="12"
            height="12"
          ></svgicon
          >{{ content.btn_exit }}
        </div>

        <!-- tutorial intro -->
        <div class="Tutorial-intro" v-if="index === 0">
          <h1 class="Tutorial__title">{{ content.title }}</h1>
          <p class="Tutorial__paragraph" v-html="content.intro"></p>
          <div class="Tutorial__cta">
            {{ content.introCall }}
            <img :src="`${baseUrl}images/svg/arrow-landing.svg`" />
          </div>
        </div>

        <template v-if="index > 0">
          <div :class="['Tutorial__steps']">
            <div class="Tutorial__step">
              <!-- nav -->
              <div class="Tutorial__steps__nav" v-if="$tvaMq === 'desktop'">
                <svgicon
                  class="arrow-left"
                  icon="icon-arrowbig-left"
                  width="30"
                  height="10"
                  v-if="index > 0"
                  @click="scrollBackward()"
                ></svgicon>
                <span class="Tutorial__steps__nav-numbers"
                  >{{ index }}/{{ sections.length - 2 }}</span
                >

                <svgicon
                  class="arrow-right"
                  icon="icon-arrowbig-right"
                  width="145"
                  height="10"
                  v-if="index + 1 !== 7"
                  @click="scrollForeward()"
                ></svgicon>
              </div>
              <transition-group name="fade">
                <!-- tutorial steps -->
                <div :key="'title-' + index" class="Tutorial__steps-title">
                  {{ content.steps[index - 1].title }}
                </div>

                <div :key="'text-' + index" class="Tutorial__steps-paragraph">
                  {{ content.steps[index - 1].text }}
                </div>
              </transition-group>
            </div>

            <!-- progress bar -->
            <div class="Tutorial__progress" v-if="index !== 0">
              <div
                class="Tutorial__progress-bar"
                :style="{ width: (100 / (sections.length - 2)) * index + '%' }"
              ></div>
            </div>
          </div>
        </template>
        <Presentation :index="index" />
      </template>
      <template v-slot:foreground>
        <section
          class="Tutorial__section"
          v-for="(section, sectionIndex) in sections"
          :id="`Tutorial__section-${sectionIndex}`"
          :key="sectionIndex"
        >
          {{ sectionIndex }}
        </section>
      </template>
    </vue-fly-scroll>
  </div>
</template>
<script>
import Menu from "@/components/Menu";
import VueFlyScroll from "@/utilities/VueFlyScroll";
import Presentation from "@/components/components-tutorial/Presentation";
import "@/compiled-icons/icon-arrowbig-left";
import "@/compiled-icons/icon-arrowbig-right";
import _ from "lodash";
import "@/compiled-icons/icon-arrow-left";
export default {
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      index: 0,
      mounted: false
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.scrollTo(0, 0);
      this.mounted = true;
    });
  },
  components: { Menu, VueFlyScroll, Presentation },
  computed: {
    sections() {
      let steps = this.$ml.get("tutorial").steps;
      return _.concat(steps, [0, 0]);
    },
    horizontalScroll() {
      return true;
    },
    content() {
      return this.$ml.get("tutorial");
    }
  },
  methods: {
    scrollForeward() {
      this.$scrollTo(`#Tutorial__section-${this.index + 1}`, 300);
    },
    scrollBackward() {
      this.$scrollTo(`#Tutorial__section-${this.index - 1}`, 300);
    },

    goBack() {
      const lastRoutePath = localStorage.getItem("LS_ROUTE_KEY");
      this.$router.push({
        path: lastRoutePath
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.Tutorial {
  background: $black;
  color: $white;
  position: relative;
  .go-back {
    position: fixed;
    top: $margin-M;
    left: 10vw;
    .icon-arrow-left {
      margin-right: 10px;
    }
  }

  &-intro {
    padding: 5vw 10vw;
    width: 100%;
  }

  &__title {
    @include HH1;
  }
  &__paragraph {
    width: 80%;
    @include HighlightS;
    margin-bottom: 20vh;
    background: $black;
  }
  &__cta {
    width: 40%;
    display: flex;
    flex-direction: column;
    @include ButtonL;
    img {
      margin-top: $margin-XS;
    }
  }
  &__steps {
    padding: 5em;
    z-index: 1;
    width: 100vw;
    height: 95vh;
    padding: 9vw 10vw $margin-M 10vw;
    // border: 2px solid salmon;
    &.hidden {
      display: none;
    }

    .Tutorial__step {
      width: 100%;
      height: 100%;
      max-width: 300px;

      .fade-enter-active,
      .fade-leave-active {
        transition: all 1.5s ease;
      }
      .fade-enter,
      .fade-leave-to {
        opacity: 0;
        position: absolute;
        top: 1000px; //todo non sono sicura sia il modo giusto..
        left: 0;
      }
    }
    &__nav {
      &-numbers {
        margin-right: $margin-S;
        @include DidaL;
      }

      .svg-icon {
        pointer-events: all;
        cursor: pointer;
        fill: $white-70;
        transition: transform 0.3s ease;

        &.arrow-left {
          margin-right: $margin-S;
        }

        &:hover {
          &.arrow-left {
            transform: translateX(-20px);
            fill: $white;
          }
          &.arrow-right {
            transform: translateX(20px);
            fill: $white;
          }
        }
      }
      margin-bottom: $margin-S;
    }
    &-title {
      @include HH3;
      margin-bottom: $margin-XS;
    }
    &-paragraph {
      display: flex;
      @include pM;
      width: 80%;

      &-number {
        margin-right: $margin-S;
      }
    }
  }
  &__section {
    height: 60vh;
    width: 100vw;
    // border: solid red 1px;
    flex-shrink: 0;
  }
  &__progress {
    height: 5px;
    width: 100%;
    margin: 0 auto;
    max-width: 1200px;
    border-radius: 5px;
    background: $white-50;
    position: relative;
    &-bar {
      height: 5px;
      background: $white;
      border-radius: 5px;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
      transition: all 0.3s ease;
    }
  }
}
</style>
